import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getAccVerificationDataThunk } from './WithdrawlThunk'

const initialState = {
	accountVerData: [],
}

export const getAccVerificationData = createAsyncThunk('user/getAccVerificationData', getAccVerificationDataThunk)

export const accVerificationSlice = createSlice({
	name: 'accVerification',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getAccVerificationData.fulfilled, (state, action) => {
			state.accountVerData = action.payload?.data?.verifiedBankDetails // Update the state with the profile data
		})
	},
})
export default accVerificationSlice.reducer
